import React from 'react';
import { LiferayService } from "../../../common/services/liferay/index";
import { decode_utf8, getSignedIdStatus } from "../../../common/utils/utilsFunc"
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";

export const VulnerableAgreementFormContext = React.createContext();

export const ACTIONS = {
    SET_LOAD_PAGE: "SET_LOAD_PAGE",  
    SET_ERROR:"SET_ERROR",
    SET_IDCLIENT:"SET_IDCLIENT",
    SET_IDCLIENT_AUX:"SET_IDCLIENT_AUX",
    SET_DETAIL_CLIENT:"SET_DETAIL_CLIENT",
    SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
    SET_RESPONSE_TYPE_INTE: "SET_RESPONSE_TYPE_INTE",
    SET_FORM_DATA: "SET_FORM_DATA",
    SET_WEB_CONTENT_TEXT_MSG:"SET_WEB_CONTENT_TEXT_MSG",
    SET_MODIFICATION_FORM_COVID: "SET_MODIFICATION_FORM_COVID",
    SET_MODIFICATION_FORM_COVID_RESPONSE: "SET_MODIFICATION_FORM_COVID_RESPONSE",
    SET_MODIFICATION_FORM_COVID_DATA: "SET_MODIFICATION_FORM_COVID_DATA",
    SET_MODIFICATION_FORM_COVID_DATA_RESPONSE: "SET_MODIFICATION_FORM_COVID_DATA_RESPONSE",
    SET_CALCULA_TU_CUOTA: "SET_CALCULA_TU_CUOTA",
    SET_CALCULA_TU_CUOTA_RESPONSE: "SET_CALCULA_TU_CUOTA_RESPONSE",
    SET_WEB_CONTENT_TERMS: "SET_WEB_CONTENT_TERMS"
};

const initialState = {
    loadPage: false,
    idClient: null,
    idClientAux: null,
    detailClient: null,
    errorFetch: null,
    webContentTerm: null,
    webContentTextInfo: "",
    typeInte: "",
    formData: "",
    webContentTextMsg: "",
    checkModificationFormCovid: null,
    checkModificationFormCovidResponse: null,
    modificationFormCovidData: null,
    modificationFormCovidDataResponse: null,
    calculaTuCuota: null,
    calculaTuCuotaResponse: null
};

const VulnerableAgreementFormReducer = (state = initialState, action) => {

    switch (action.type){
        case ACTIONS.SET_FORM_DATA: {
            return {
                ...state,
                formData: action.payload
            };
        }
        case ACTIONS.SET_FORM_DATA_RESPONSE: {
            return {
                ...state,
                formDataResponse: action.payload
            };
        }
        case ACTIONS.SET_RESPONSE_TYPE_INTE: {
            return {
                ...state,
                responseTypeInte: action.payload
            };
        }
        case ACTIONS.SET_LOAD_PAGE: {
            return {
                ...state,
                loadPage: action.payload
            };
        }
        case ACTIONS.SET_IDCLIENT: {
            return {
                ...state,
                idClient: action.payload
            };
        }
        case ACTIONS.SET_IDCLIENT_AUX: {
            return {
                ...state,
                idClientAux: action.payload
            };
        }
        case ACTIONS.SET_DETAIL_CLIENT: {
            return {
                ...state,
                detailClient: action.payload
            };
        }
        case ACTIONS.SET_ERROR: {
            return {
                ...state,
                errorFetch: action.payload
            };
        }
        case ACTIONS.SET_WEB_CONTENT_TERMS: {
            return {
                ...state,
                webContentTerm: action.payload
            };
        }
        case ACTIONS.SET_WEB_CONTENT_TEXT_MSG: {
            return {
              ...state,
              webContentTextMsg: action.payload,
            };
        }
        case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
            return {
              ...state,
              webContentTextInfo: action.payload,
            };
        }
        case ACTIONS.SET_MODIFICATION_FORM_COVID: {
            return {
              ...state,
              checkModificationFormCovid: action.payload,
            };
        }
        case ACTIONS.SET_MODIFICATION_FORM_COVID_RESPONSE: {
            return {
              ...state,
              checkModificationFormCovidResponse: action.payload,
            };
        }
        case ACTIONS.SET_MODIFICATION_FORM_COVID_DATA: {
            return {
              ...state,
              modificationFormCovidData: action.payload,
            };
        }
        case ACTIONS.SET_MODIFICATION_FORM_COVID_DATA_RESPONSE: {
            return {
              ...state,
              modificationFormCovidDataResponse: action.payload,
            };
        }
        case ACTIONS.SET_CALCULA_TU_CUOTA: {
            return {
              ...state,
              calculaTuCuota: action.payload,
            };
        }
        case ACTIONS.SET_CALCULA_TU_CUOTA_RESPONSE: {
            return {
              ...state,
              calculaTuCuotaResponse: action.payload,
            };
        }
        default: {
            return state;
        }
    }

};

const VulnerableAgreementFormContextProvider = ({children}) => {
    const properties = React.useContext(ApplicationPropertiesContext);
    const [state, dispatch] = React.useReducer(VulnerableAgreementFormReducer, initialState)

    React.useEffect(() => {
            LiferayService.getWebContent(properties.base_url_api,properties.webcontent_terms_page_vulnereble_agreement)
            .then((response) => {
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_WEB_CONTENT_TERMS,
                });
            })
            if (decode_utf8(properties.web_content_info_update_of_contact_information)?.trim()) {
                LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information)?.trim())
                .then((response) => {
                    dispatch({
                    payload: response,
                    type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
                    });
                })
            }
            if (decode_utf8(properties.select_no_content_name_vulnereble_agreement)?.trim()) {
                LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.select_no_content_name_vulnereble_agreement)?.trim())
                .then((response) => {
                    dispatch({
                    payload: response,
                    type: ACTIONS.SET_WEB_CONTENT_TEXT_MSG,
                    });
                })
            }
            if (decode_utf8(properties.tag_vulnereble_agreement)?.trim()) {
                LiferayService.getListTipoInteracciones(properties.base_url_api,decode_utf8(properties.tag_vulnereble_agreement).trim())
                .then((response) => {
                    dispatch({
                    payload: response,
                    type: ACTIONS.SET_RESPONSE_TYPE_INTE,
                    });
                });
            }
    }, [])

    React.useEffect(() => {

        if(state.idClient){

            dispatch({
                type:ACTIONS.SET_IDCLIENT_AUX,
                payload: state.idClient
            })

            LiferayService.consultarDetalleCuentaContrato(properties.base_url_api,state.idClient, properties.url_ws_empresa, properties.codigo_empresa)
            .then((response) =>{
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_DETAIL_CLIENT,
                });
                dispatch({
                    payload: null,
                    type: ACTIONS.SET_ERROR,
                });
                dispatch({
                    type:ACTIONS.SET_IDCLIENT,
                    payload: ""
                  })
                })
            .catch((error) => {
                dispatch({
                payload: error,
                type: ACTIONS.SET_ERROR,
                });
            })
        }

    },[state.idClient])

    React.useEffect(() => {
        if(state.formData){
            LiferayService.sendFormConvVulne(properties.base_url_api,state.formData, properties.url_ws_empresa, properties.codigo_empresa,getSignedIdStatus())
            .then((response) => {
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_FORM_DATA_RESPONSE,
                });
            }).catch((error) => {
                dispatch({
                    payload: error,
                    type: ACTIONS.SET_ERROR,
                });
            })
        }
    },[state.formData])

    React.useEffect(() => {
        if(state.checkModificationFormCovid) {
            LiferayService.checkModificationFormCovid(properties.base_url_api, state.checkModificationFormCovid)
            .then((response) => {
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_MODIFICATION_FORM_COVID_RESPONSE,
                });
            }).catch((error) => {
                dispatch({
                    payload: error,
                    type: ACTIONS.SET_ERROR,
                });
            })
        }
    }, [state.checkModificationFormCovid])

    React.useEffect(() => {
        if(state.calculaTuCuota) {
            LiferayService.calculateFeeCovidForm(properties.base_url_api, state.calculaTuCuota)
            .then((response) => {
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_CALCULA_TU_CUOTA_RESPONSE,
                });
            }).catch((error) => {
                dispatch({
                    payload: error,
                    type: ACTIONS.SET_ERROR,
                });
            })
        }
    }, [state.calculaTuCuota])

    React.useEffect(() => {
        if(state.modificationFormCovidData) {
            LiferayService.modifyCovidFormData(properties.base_url_api, state.modificationFormCovidData)
            .then((response) => {
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_MODIFICATION_FORM_COVID_DATA_RESPONSE,
                });
            }).catch((error) => {
                dispatch({
                    payload: error,
                    type: ACTIONS.SET_ERROR,
                });
            })
        }
    }, [state.modificationFormCovidData])

    return (
        <VulnerableAgreementFormContext.Provider value={[state, dispatch]}>
            {children}
        </VulnerableAgreementFormContext.Provider>

    )
}

export default VulnerableAgreementFormContextProvider;